export function formatDonorDisplayName(
  firstName?: string | null,
  lastName?: string | null,
): string {
  const name = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  return name || "Anonymous";
}
